import React from 'react';
import * as styles from './allhomes-mobile-divider.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var AllhomesMobileDivider = () => ___EmotionJSX("div", {
  css: styles.content
});
export default AllhomesMobileDivider;